import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { purchaseNotifications } from '../data/content';
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timeout: number;
    const cycle = () => {
      setVisible(true);
      timeout = window.setTimeout(() => {
        setVisible(false);
        setIndex(prev => (prev + 1) % purchaseNotifications.length);
        timeout = window.setTimeout(cycle, 9000);
      }, 5500);
    };
    timeout = window.setTimeout(cycle, 6000);
    return () => window.clearTimeout(timeout);
  }, [dismissed, index]);
  if (dismissed) return null;
  const item = purchaseNotifications[index];
  return <AnimatePresence data-id="element-37" data-mp="1gzgowg7d5632">
      {visible && <motion.div initial={{
      opacity: 0,
      x: -20
    }} animate={{
      opacity: 1,
      x: 0
    }} exit={{
      opacity: 0,
      x: -20
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-24 left-3 right-3 z-30 sm:right-auto sm:max-w-xs" role="status" aria-live="polite" data-id="element-38" data-mp="1gydwu4yb0xlk">
          <div className="flex items-start gap-3 rounded-xl border border-sky-400/30 bg-navy-800 p-3 shadow-[0_12px_34px_-12px_rgba(0,0,0,0.9)]" data-id="element-39" data-mp="1awfrzta2p398">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-emerald-400" aria-hidden="true" data-id="element-40" data-mp="n97nveods08s" />
            <div className="min-w-0 flex-1" data-id="element-41" data-mp="iaek4dywbnlt">
              <p className="text-sm font-semibold leading-snug text-white" data-id="element-42" data-mp="x5kpcyq63ie3">
                {item.name} just purchased the TRT Decision Deck™
              </p>
              <p className="mt-0.5 text-xs text-sky-200/70" data-id="element-43" data-mp="s8khqjdo67kv">
                {item.country} · a few minutes ago
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="-mr-1 -mt-1 rounded p-1 text-sky-200/50 transition-colors duration-150 ease-out hover:text-white" data-id="element-44" data-mp="23kbnwvrtir4y">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-45" data-mp="2kmhfr5bkh71d" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}